import { GatsbyImage } from 'gatsby-plugin-image'
import React from 'react'
import { Box, Flex, Image } from 'theme-ui'
import ClueImage from './ClueImage'

const ClubHouseHero = ({ heroSection, formId, width }) => {
  const { image } = heroSection

  //fix housedude and calculate based on height to grass ratio
  const dudeHeights = [175, 250, 347]
  const grassRatio = 0.244
  const grassHeights = dudeHeights.map(h => `${h * grassRatio}px`)
  return (
    <Flex
      sx={{
        position: 'relative',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        height: '100%',
        width: '100vw',
        pt: ['2rem', '100px'],
      }}
    >
      <GatsbyImage
        image={image.gatsbyImageData}
        alt={image.alt}
        objectFit="cover"
        style={{
          zIndex: 0,
          position: 'absolute',
          width: '100%',
          height: '100%',
        }}
      />
      <Flex
        sx={{
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 1,
          position: 'relative',
          width: '100%',
          height: '100%',
        }}
      >
        <Image
          src={'/images/clubhouse/hero/hero_flag_text.png'}
          alt={'Hero Flag'}
          sx={{
            display: ['none', 'none', 'block'],
            width: ['90%', '100%', '100%'],
            height: '100%',
            zIndex: 10,
            maxWidth: ['378px', '378px', '674px'],
            objectFit: 'contain',
            mb: ['-1rem', '-1rem', '-4rem'],
          }}
        />
        <Image
          src={'/images/clubhouse/hero/hero_flag_mobile_text.png'}
          alt={'Hero Flag Mobile'}
          sx={{
            display: ['block', 'block', 'none'],
            width: ['90%', '100%', '100%'],
            height: '100%',
            zIndex: 10,
            maxWidth: ['378px', '378px', '674px'],
            objectFit: 'contain',
            mb: ['-1rem', '-1rem', '-4rem'],
          }}
        />
        <ClueImage formId={formId} width={width} />
      </Flex>
      <Image
        src="/images/clubhouse/hero/housedude.png"
        alt="House Dude"
        sx={{
          position: 'absolute',
          bottom: 0,
          right: '25%',
          height: dudeHeights,
          objectFit: 'contain',
          zIndex: 50,
          pointerEvents: 'none',
        }}
      />
      <Box
        sx={{
          position: 'absolute',
          bottom: 0,
          left: 0,
          width: '100vw',
          height: grassHeights,
          backgroundImage: 'url("/images/clubhouse/hero/housedude_grass.png")',
          backgroundRepeat: 'repeat-x',
          backgroundPosition: 'bottom',
          backgroundSize: 'auto 100%',
          zIndex: 40,
          pointerEvents: 'none',
        }}
      />
    </Flex>
  )
}

export default ClubHouseHero
